import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

export class BaseService {
  protected host: string = environment.apiUrl;
  public entityName: string;
  protected token = sessionStorage.getItem("token");

  constructor(public http: HttpClient) { }

  protected headers(isFormData = false, extraOptions = {}): HttpHeaders {

    let result: any = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    if (isFormData) {
      result = {
        // "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
      };
    }

    this.token = localStorage.getItem("token");

    if (this.token) {
      result.Authorization = this.token;
    }

    for (const key in extraOptions) {
      result[key] = extraOptions[key];
    }

    return new HttpHeaders(result);
  }

  protected headersWithoutToken(isFormData = false): HttpHeaders {

    let result: any = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    if (isFormData) {
      result = {
        // "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "Access-Control-Allow-Origin": "*",
      };
    }

    return new HttpHeaders(result);
  }

  private options(isFormData = false, extraOptions = {}): any {
    const headerOptions = this.headers(isFormData, extraOptions);
    return { headers: headerOptions };
  }

  private optionsWithoutToken(isFormData = false): any {
    const headerOptions = this.headersWithoutToken(isFormData);
    return { headers: headerOptions };
  }

  getResources(params = {}) {
    return this.http.get(this.resourceUrl(null, params), this.options());
  }

  getResource(id, position = null, params = {}) {
    return this.http.get(this.resourceUrl(id, position, params), this.options());
  }

  createResource(data, params = {}) {

    let isFormData = false;

    if (data instanceof FormData) {
      isFormData = true;
    }

    return this.http.post(
      this.resourceUrl(null, params),
      data,
      this.options(isFormData)
    );
  }

  upload(formData) {
    return this.http.post(`${this.host}/${this.entityName}`, formData, {
      reportProgress: true,
      observe: "events",
      headers: this.headers(true),
    });
  }

  updateResource(data, params = {}) {
    let isFormData = data instanceof FormData;
    return this.http.put(
      this.resourceUrl(data.id, params),
      data,
      this.options(isFormData)
    );
  }

  patchResource(data, params = {}) {
    return this.http.patch(
      this.resourceUrl(data.id, params),
      data,
      this.options(false)
    );
  }

  patchResourceDynamic(id = null, body, position, params = {}, extraOptions = {}) {
    extraOptions = {
      "Content-Type": "application/merge-patch+json"
    }
    return this.http.patch(
      this.resourceUrl(id, position, params),
      body,
      { headers: this.headers(false, extraOptions) }
    );
  }

  patchResourceWithoutToken(data, params = {}) {
    return this.http.patch(
      this.resourceUrl(data.id, params),
      data,
      this.optionsWithoutToken(false)
    );
  }

  deleteResource(id = null) {
    return this.http.delete(this.resourceUrl(id), this.options());
  }

  rawGet(url) {
    return this.http.get(url);
  }

  resourceUrl(id = null, position = null, params = {}) {

    switch (this.entityName) {
      case "login":
      case "signin":
      case "signout":
      case "password-recovery":
      case "password-change":
        this.host = environment.rawAPI;
        break;
    
      default:
        this.host = environment.apiUrl;
        break;
    }

    let base = [
      this.host,
      this.urlParameters(params),
      this.entityName,
      id
    ];

    if (position == 'middle') {

      base = [
        this.host,
        this.urlParameters(params),
        this.entityName
      ];

    }

    const endpoint = base
      .filter((element) => element)
      .join("/")
      .replace(/\/$/, "");

    let url = endpoint + this.queryString(params);

    let client_id: any = localStorage.getItem("empresa_id");
    if (client_id) {
      if (url.indexOf("?") >= 0) url = url + "&";
      else url = url + "?";
      url = url + "client_id=" + client_id;
    }

    return url;
  }

  protected urlParameters(params) {
    var urlParameters = [];

    for (var placeholder in params) {
      if (/.*_id$/.test(placeholder)) {
        urlParameters.push(`${placeholder}/${params[placeholder]}`);
      }
    }

    return urlParameters.join("/");
  }

  protected queryString(params) {
    if (params.query) {
      return `?${params.query}`;
    } else if (params.router) {
      return `/${params.router}`;
    } else {
      return "";
    }
  }
}
